import { RootAppState } from 'store/configureStore'

export const projectVisibleInPortalSelector = (state: RootAppState) => {
  return state.project.activeProject?.visibleInPortal
}
